<template>
  <div class="Upsell" :data-ht-module="`${location}-upsell`">
    <div class="Upsell__Header">
      <p v-if="title" class="t4" data-color="night-sky-dark">
        {{ title }}
      </p>
      <div
        class="Upsell__Arrows"
        :class="buttonClasses"
        v-if="hasMoreThanOneSlide"
      >
        <button
          role="button"
          type="button"
          aria-label="Previous product"
          @click="upsell.go('-')"
          :aria-disabled="atStart"
          data-direction="prev"
        >
          <span class="hidden">Previous</span>
          <Icon :icon="'splide-arrow'" />
        </button>
        <button
          role="button"
          type="button"
          aria-label="Next product"
          @click="upsell.go('+')"
          :aria-disabled="atEnd"
          data-direction="next"
        >
          <span class="hidden">Next</span>
          <Icon :icon="'splide-arrow'" />
        </button>
      </div>
    </div>
    <Splide
      v-if="hasItems"
      :id="`${location}-upsell`"
      role="group"
      :options="settings"
      ref="upsell"
      @splide:move="onMove"
      @splide:mounted="setRole"
    >
      <SplideSlide v-for="item in items" :key="item">
        <UpsellTile
          v-if="item"
          :item="item"
          :location="location"
          :pre-selection="preSelection"
          :selection-listener="selectionListener"
        />
      </SplideSlide>
    </Splide>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Icon from './Icon.vue';
import { pubSub } from '@utils/PubSub';
import UpsellTile from './UpsellTile.vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';

const props = defineProps({
  items: Array,
  preSelection: {
    type: String,
    required: false,
    default: '',
  },
  selectionListener: {
    type: Boolean,
    required: false,
    default: false,
  },
  title: {
    type: [String, Boolean],
    required: false,
    default: false,
  },
  location: {
    type: String,
    required: false,
    default: '',
  },
});

const upsell = ref(null);
const atEnd = ref(false);
const atStart = ref(true);

const hasItems = computed(() => {
  const items = props.items.filter((item) => item);
  return items.length > 0;
});

const hasMoreThanOneSlide = computed(() => {
  const items = props.items.filter((item) => item);
  return items.length > 1;
});

const buttonClasses = computed(() => {
  if (atStart.value) {
    return 'Upsell__Arrows--Start';
  }
  if (atEnd.value) {
    return 'Upsell__Arrows--End';
  }
});

const settings = {
  arrows: false,
  pagination: hasMoreThanOneSlide.value,
  mediaQuery: 'min',
  perMove: 1,
  perPage: 1,
  role: 'group',
  easing: 'cubic-bezier(.33, 1, .68, 1)',
};

const onMove = (splide) => {
  const slider = splide.Components.Controller;
  const index = slider.getIndex();
  const end = slider.getEnd();
  atEnd.value = index === end;
  atStart.value = index === 0;
  pubSub.publish('upsell:move');
};

const setRole = (splide) => {
  splide.root.querySelector('.splide__list').setAttribute('role', 'group');
};
</script>
